import React from 'react';
import fr from 'facet-rest';
import { pickImplementation } from 'Helpers/Affordances';
import ProjectedMeetings from 'Components/UI/ProjectedMeetings';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

const ListFooter = ({ className }) => {
  const { householdResource } = useSimpleHousehold();

  return pickImplementation(householdResource, {
    [fr.relationships.default.name]: (
      <ProjectedMeetings className={className} />
    ),
  });
};

export default ListFooter;
